import PropTypes from 'prop-types'
import { gql } from '@apollo/client'

const thumbnailWithUrl = gql`
  fragment thumbnailWithUrl on ThumbnailWithUrl {
    id
    type
    status
    title
    subtitle
    url
    imageUrl
  }
`

export const thumbnailWithUrlPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'THUMBNAIL_EVENT_COLLECTION',
    'THUMBNAIL_WITH_URL',
    'THUMBNAIL_BLOG',
    'GROUP_COLLECTION',
    'RECURRING_EVENT_COLLECTION',
    'RECOMMENDED_EVENT_COLLECTION',
  ]).isRequired,
  status: PropTypes.oneOf(['ACTIVE', 'PREVIEW']).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  url: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
})

export default thumbnailWithUrl
